import { Routes, Route } from 'react-router-dom';
import { ErrorBoundary } from '@shared/lib/error-boundary';
import MainPage from '@/pages/main/ui/MainPage';
import MapPage from '@/pages/map/ui/MapPage';
import NotFoundPage from '@/pages/notfound/ui/NotFoundPage';
import KnowledgePage from '@/pages/knowledge/ui/KnowledgePage';
import { PreloaderWrapper } from '@shared/ui/PreloaderWrapper';
import PrivacyPolicyPage from '@/pages/privacy_policy/PrivacyPolicy';

export const App = () => {
  return (
    <ErrorBoundary>
      <PreloaderWrapper>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/map" element={<MapPage />} />
          <Route path="/buildings/:id" element={<KnowledgePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </PreloaderWrapper>
    </ErrorBoundary>
  );
};
